import { Address_Schema } from "@/services/addresses/addressSchema";
import { OrderId_Schema, OrderProduct_Schema, OrderProductId_Schema, OrderStatus_Schema } from "@/services/marketplace/order/orderSchema";
import { Parcel_Schema } from "@/services/marketplace/order/parcels";
import { PaymentMethod_Schema } from "@/services/marketplace/paymentMethod";
import { ShippingMethod_Schema } from "@/services/marketplace/shippingMethod";
import { PriceNumeric_Schema } from "@/services/prices";
import { UserId_Schema } from "@/services/user";
import { Nickname_Schema } from "@/services/user/profile";
import { Rating_Schema } from "@/services/user/rating";
import { DateTimeObject_Schema, NaturalNumber_Schema, WholeNumber_Schema } from "@/utilities";
import { z } from "zod";

export const PaymentId_Schema = NaturalNumber_Schema;

export const Sale_Schema = z
  .object({
    id: OrderId_Schema,
    address: Address_Schema,
    commissionPrice: PriceNumeric_Schema,
    created: DateTimeObject_Schema,
    updated: DateTimeObject_Schema,
    delivery: ShippingMethod_Schema,
    deliveryInfo: Parcel_Schema.array(),
    payment: PaymentMethod_Schema,
    paymentInfo: z.object({
      isPaid: z.boolean(),
      paymentUrl: z.url().nullable(), // absolute URL
      paymentState: z.string(), // See https://doc.gopay.com/#state
    }),
    orderItems: OrderProduct_Schema.array(),
    priceItems: PriceNumeric_Schema,
    status: z.object({
      created: DateTimeObject_Schema,
      status: OrderStatus_Schema,
      daysRemaining: z.string().nullable(), // Already formatted and translated string, e.g. "2 dny"
    }),
    price: PriceNumeric_Schema,
    seller: z.object({
      id: UserId_Schema,
      avatarUrl: z.url().nullable(),
      nickname: Nickname_Schema,
      orderSellerItems: z
        .object({
          id: OrderProductId_Schema,
        })
        .array(),
      price: PriceNumeric_Schema,
      rating: Rating_Schema,
      ratingCount: WholeNumber_Schema,
    }),
    user: z.object({
      id: UserId_Schema,
      avatarUrl: z.url().nullable(),
      nickname: Nickname_Schema,
      rating: Rating_Schema,
      ratingCount: WholeNumber_Schema,
    }),
  })
  .transform((response) => ({
    orderId: response.id,
    updatedDateTime: response.updated,
    createdDateTime: response.created,
    status: response.status.status,
    daysRemaining: response.status.daysRemaining,
    shipping: {
      address: response.address,
      method: response.delivery,
      parcels: response.deliveryInfo,
    },
    payment: {
      method: response.payment,
      url: response.paymentInfo.paymentUrl,
      isPaid: response.paymentInfo.isPaid,
      state: response.paymentInfo.paymentState,
      totalPrice: response.price,
    },
    products: response.orderItems,
    priceProducts: response.priceItems,
    commissionPrice: response.commissionPrice,
    buyer: response.user,
    seller: response.seller,
  }));
